var _circle, _circle2, _circle3, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#292374"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 35
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#5985CF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "url(#paint0_radial)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 35
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 35C27.165 35 35 27.165 35 17.5C35 7.83502 27.165 0 17.5 0C7.83502 0 0 7.83502 0 17.5C0 27.165 7.83502 35 17.5 35Z",
    fill: "#36A9E1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.4194 30.2904C28.3131 31.4287 27.0471 32.2823 24.6139 33.5628C22.5093 34.6704 19.8832 35.0223 17.5035 35.0223C15.1238 35.0223 12.3781 34.4809 10.244 33.4205C7.95316 32.2823 6.97165 31.7132 5.58765 30.2904C6.03287 29.2598 6.7704 26.5482 7.95316 25.8631C9.03876 25.2362 10.5569 24.8165 12.239 24.5553C13.921 24.294 15.7627 24.187 17.5005 24.187C20.9753 24.187 24.8742 24.6084 27.0471 25.8631C28.2366 26.5482 28.9707 29.2598 29.4194 30.2904Z",
    fill: "#99AAE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4194 30.2904C28.3131 31.4287 27.0471 32.2823 24.6139 33.5628C22.5093 34.6704 19.8832 35.0223 17.5035 35.0223C15.1238 35.0223 12.3781 34.4809 10.244 33.4205C7.95316 32.2823 6.97165 31.7132 5.58765 30.2904C6.03287 29.2598 6.7704 26.5482 7.95316 25.8631C9.03876 25.2362 10.5569 24.8165 12.239 24.5553C13.921 24.294 15.7627 24.187 17.5005 24.187C20.9753 24.187 24.8742 24.6084 27.0471 25.8631C28.2366 26.5482 28.9707 29.2598 29.4194 30.2904Z",
    fill: "url(#paint1_linear)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9708 24.4071V21.0599H14.0297V24.4071C12.9762 24.5857 12.2429 24.9447 12.2429 25.6989C12.2429 27.1711 14.2418 28.7014 17.4994 28.7014C20.8787 28.7014 22.7568 27.1711 22.7568 25.6989C22.7568 24.9447 22.0235 24.5857 20.9708 24.4071Z",
    fill: "#DAD4FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2646 16.9645C13.2646 15.9238 12.8075 14.6581 12.244 14.6581C11.6805 14.6581 11.1018 14.8586 11.1018 15.8985C11.1018 16.4041 11.2801 17.5215 11.4533 18.0128C11.6391 18.5429 11.9517 18.8471 12.244 18.8471C12.8075 18.8471 13.2646 18.0044 13.2646 16.9645Z",
    fill: "#DAD4FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7356 16.9645C21.7356 15.9238 22.1926 14.6581 22.7561 14.6581C23.3196 14.6581 23.8984 14.8586 23.8984 15.8985C23.8984 16.4041 23.7201 17.5215 23.5469 18.0128C23.361 18.5429 23.0485 18.8471 22.7561 18.8471C22.1926 18.8471 21.7356 18.0044 21.7356 16.9645Z",
    fill: "#F2B99A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9711 21.8428V23.6184C20.8262 23.7453 20.6744 23.8643 20.5166 23.9748C19.9117 24.3962 19.4859 24.6726 19.0888 24.8386C18.6931 25.0025 18.2668 25.0803 17.8385 25.0669C16.8661 25.0669 16.3685 24.8234 15.1612 23.9715C14.7356 23.6728 14.3548 23.3153 14.03 22.9097V21.8437C14.2717 22.0931 14.5367 22.3189 14.8216 22.5178C16.0306 23.3681 16.5282 23.6133 17.5006 23.6133C17.9291 23.6269 18.3556 23.5493 18.7518 23.3858C19.148 23.2172 19.5738 22.9451 20.1787 22.5204C20.4643 22.3208 20.7297 22.0939 20.9711 21.8428Z",
    fill: "#DB9172",
    fillOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5004 8.26294C13.3228 8.26294 12.1831 11.8536 12.1831 16.2836C12.1831 19.222 13.104 21.3144 14.8215 22.5195C16.0304 23.3689 16.528 23.6149 17.5004 23.6149C18.472 23.6149 18.9696 23.3722 20.1785 22.5195C21.8961 21.3119 22.8169 19.2195 22.8169 16.2836C22.8169 11.8536 21.6773 8.26294 17.5004 8.26294Z",
    fill: "#DAD4FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4994 8.26294C17.4276 8.26294 17.3583 8.26294 17.2882 8.26884C20.9843 8.39019 22.0032 11.9303 22.0032 16.2836C22.0032 19.222 21.1524 21.3144 19.5667 22.5194C18.5343 23.3048 18.0629 23.5711 17.2856 23.6074C17.3541 23.6074 17.4242 23.6074 17.4969 23.6074C18.4692 23.6074 18.9669 23.3647 20.1758 22.5119C21.8933 21.3043 22.8142 19.2119 22.8142 16.276C22.8167 11.8536 21.6771 8.26294 17.4994 8.26294Z",
    fill: "#ECA182",
    fillOpacity: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1467 10.3418C24.0436 9.50927 23.4007 7.46324 22.4384 7.33262C22.0008 7.27363 21.7262 7.5197 21.3942 7.36549C21.1222 7.23993 19.9512 5.80484 18.9442 5.30344C17.726 4.69587 15.9434 4.32172 14.7344 4.71356C13.2501 5.19473 13.3092 6.40988 12.7423 6.87842C12.1755 7.34695 11.1997 7.88964 11.1186 8.58653C10.9952 9.64495 11.5148 10.4826 11.476 11.482C11.4455 12.2876 10.9691 13.0603 11.1659 13.8769C11.2698 14.31 11.8046 14.6252 11.8849 15.0693C11.9305 15.3221 11.9938 15.944 12.1814 16.1513C12.5835 16.5988 12.5852 13.737 12.679 12.8834C12.7567 12.1654 12.9831 11.3615 13.3971 10.7505C13.9293 9.96348 14.7834 10.0562 15.6198 10.2382C16.4697 10.4219 17.2639 10.593 18.1467 10.491C19.0295 10.389 19.9648 9.99297 20.8248 10.4067C21.6325 10.7944 22.1022 11.6708 22.2939 12.5059C22.3903 12.923 22.3083 15.7544 22.7544 15.9423C22.9892 16.0409 23.072 15.1072 23.5147 14.7912C23.8957 14.5199 24.0081 14.1946 24.0934 13.7446C24.308 12.6365 24.2844 11.4525 24.1467 10.3418Z",
    fill: "#7868DB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7571 15.9389C22.3119 15.751 22.393 12.9196 22.2975 12.5025C22.1057 11.6674 21.6352 10.791 20.8275 10.4042C19.9675 9.99128 19.0314 10.3857 18.1494 10.4885C17.2674 10.5913 16.4716 10.4211 15.6225 10.2357C14.7735 10.0503 13.9329 9.96095 13.399 10.7472C12.9858 11.359 12.7594 12.1629 12.6817 12.8817C12.5972 13.673 12.5862 16.196 12.2593 16.196C12.6031 16.2339 12.7425 14.16 12.8295 13.4598C12.9081 12.8278 13.0585 11.7744 13.4775 11.2385C14.2759 10.2138 15.1325 10.4876 15.9351 10.7741C16.8239 11.0901 17.2623 11.2587 18.1452 11.1677C19.028 11.0767 19.9633 10.7303 20.8233 11.0935C21.6309 11.4348 22.1505 12.1148 22.2595 13.0443C22.3043 13.4218 22.3043 15.8033 22.7495 15.9684C22.774 15.9777 22.7909 15.9684 22.801 15.9423C22.7863 15.9451 22.7712 15.9439 22.7571 15.9389ZM12.1528 16.1075C12.16 16.1246 12.1707 16.1401 12.1841 16.153C12.1932 16.1627 12.2038 16.1709 12.2153 16.1774C12.2039 16.1684 12.1934 16.1583 12.1841 16.1471C12.173 16.1356 12.1625 16.1235 12.1528 16.1108V16.1075Z",
    fill: "#DB9172",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.5 5.71008) rotate(90) scale(29.2899)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#901B7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5221C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 28.5977,
    y1: 28.7399,
    x2: 5.69116,
    y2: 28.7399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D81DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99AAE0",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleIcon);
export default __webpack_public_path__ + "static/media/maleIcon.37e453c9a8d10a32b5745b2e47635fd5.svg";
export { ForwardRef as ReactComponent };